export const BANNERS = {
  "300x250px": {
    width: 300,
    height: 250,
    fileName: "hp_300_250_banner.jpg",
  },
  "320x100px": {
    width: 320,
    height: 100,
    fileName: "hp_320_100_banner.jpg",
  },
} as const;

export const RECEPTION_CLINIC_AVAILABLE_BANNERS = {
  "300x160px": {
    width: 300,
    height: 160,
    fileName: "hp_300_160_reception_clinic_banner.jpg",
  },
  "360x120px": {
    width: 360,
    height: 120,
    fileName: "hp_360_120_reception_clinic_banner.jpg",
  },
  "480x100px": {
    width: 480,
    height: 100,
    fileName: "hp_480_100_reception_clinic_banner.jpg",
  },
} as const;

export const FAST_PASS_RECEPTION_CLINIC_AVAILABLE_BANNERS = {
  "300x284px": {
    width: 300,
    height: 284,
    fileName: "hp_300_284_fast_pass_reception_clinic_banner.jpg",
  },
  "540x120px": {
    width: 540,
    height: 120,
    fileName: "hp_540_120_fast_pass_reception_clinic_banner.jpg",
  },
} as const;
